import React, { useState } from "react";
import { BellIcon, MessageIcon } from "../Icons";
import { useNavigate } from "react-router-dom";
import {GetPageTitle} from "../../utils/index.js"
import NotificationModal from "../NotificationModal/index.js";


const Header = () => {

  const [modalshow, setModalshow] = useState(false)

  const navigate=useNavigate()

  const handleConfirm = async () => {
    setModalshow(false)
  }

  return (

    <>
    <div className="mainHeader">
      <div className="mainHeaderLeft">
        {/* <h2>Policy & Compliance Auditor</h2> */}
        <h2>{GetPageTitle()}</h2>
      </div>
      <div className="mainHeaderRight">
        <div className="iconBox">
          <MessageIcon />
        </div>
        <div onClick={()=>{setModalshow(true)}} className="iconBox">
          <BellIcon />
        </div>
        <div onClick={()=>{navigate('/profile-setting')}} className="profileIconBox">
          <p>JD</p>
        </div>
      </div>
    </div>

<NotificationModal key={'modal'} visible={modalshow} onClose={handleConfirm} />
</>
  );
};

export default Header;
